import Vue from "vue";
import mixin from "../../../mixins/mixin";
import paymentService from "../../../services/payment";
import accountService from "../../../services/account";

export default {
  data() {
    return {
      success: this.$t("payments.success"),
      error: null,
      loading: false,
      reservationId: "",
      message: "",
      payment: {},
      pageTitle: "",
      userCurrency: "€",
      status: "success",
      stripe: null,
    };
  },
  components: {
    VLayout: require("layouts/default/default.vue"),
    VPanel: require("components/panel/panel.vue"),
    VLoading: require("components/loading/loading.vue"),
  },
  mixins: [mixin],
  async mounted() {
    let vm = this;
    vm.loading = true;
    vm.reservationId = this.$route.params.reservationId;

    const searchParams = new URLSearchParams(window.location.search);
    const paymentIntentClientSecret = searchParams.get(
      "payment_intent_client_secret"
    );

    // console.log("reservation id param", this.$route.params.reservationId);
    // console.log(
    //   "reservation payment intent param",
    //   searchParams.get("payment_intent")
    // );
    // console.log(
    //   "reservation payment intent client secret param",
    //   searchParams.get("payment_intent_client_secret")
    // );

    await accountService.getConnectedStripePublicKeyForBookingReservation(
      this,
      vm.reservationId
    );

    if (vm.stripe && paymentIntentClientSecret) {
      vm.stripe
        .retrievePaymentIntent(paymentIntentClientSecret)
        .then((result) => {
          vm.confirm3dsAuthentication(vm.reservationId, result.paymentIntent);

          // if (
          //   result.paymentIntent &&
          //   result.paymentIntent.last_payment_error &&
          //   result.paymentIntent.last_payment_error.code &&
          //   result.paymentIntent.last_payment_error.code ===
          //     "payment_intent_authentication_failure"
          // ) {
          //   console.log("payment_intent_authentication_failure");
          //   vm.loading = false;
          //   vm.status = "error";
          //   toastr.error(this.$t('payments.error.card_declined'));
          // } else if (result.paymentIntent.status === "succeeded") {
          //   console.log("succeeded");
          //   vm.loading = false;
          //   let data = {
          //     confirmed_intent: result.paymentIntent,
          //   };
          //   vm.confirm3dsAuthentication(vm.reservationId, data);
          // } else if (
          //   result.paymentIntent.status === "requires_payment_method"
          // ) {
          //   console.log("requires_payment_method");
          //   vm.loading = false;
          // }
        });
    }
  },

  methods: {
    async confirm3dsAuthentication(reservationId, paymentIntent) {
      let vm = this;
      let parameters = {
        reservation_id: reservationId,
        confirmed_intent: paymentIntent,
      };
      await paymentService.confirm3dsAuthentication(vm, parameters);

      vm.loading = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/payments/confirm3dsAuthentication/confirm3dsAuthentication.js